<template>
  <div class="px-4 py-2 border border-gray-300 rounded">
    <div class="flex justify-between">
      <div class="flex items-center space-x-2">
        <div>
          <input
            type="checkbox"
            v-model="shouldProcess"
            :id="`should-process-${_uid}`"
            v-on:change="toggleProcessing()"
          />
        </div>
        <label :for="`should-process-${_uid}`">
          <div class="text-sm">
            {{ productName }}
          </div>
          <div class="text-gray-500 text-xs">
            {{ variant.variant_name }} ({{ variant.id }})
          </div>
        </label>
      </div>
      <div class="flex flex-col space-y-1 whitespace-no-wrap">
        <div>Quantity:</div>
        <div>
          <input
            v-model="quantity"
            v-on:input="updateProcessing()"
            class="w-15 px-1 border rounded"
            min="0"
            step="1"
            type="number"
            :max="Number(product.QuantityOrdered)"
          />
        </div>
      </div>
      <div class="flex flex-col space-y-1 whitespace-no-wrap">
        <div>Amount (each):</div>
        <div>
          <input
            v-model="amount"
            v-on:change="
              amount = null;
              amount = decimal($event.target.value);
            "
            v-on:input="updateProcessing()"
            type="number"
            step="0.01"
            class="w-24 px-1 border rounded"
            min="0"
          />
        </div>
      </div>
      <div class="flex flex-col space-y-1 whitespace-no-wrap">
        <div>Total:</div>
        <div>
          {{ total | currency }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moneyFormatter from "@/mixins/moneyFormatter";

export default {
  name: "AdjustmentProduct",
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  filters: {
    currency: moneyFormatter.format,
  },
  data() {
    return {
      originalReplacementQuantity: null,
      showReplacements: false,
      loadingReplacements: false,
      loadedReplacements: false,
      shouldProcess: false,
      originalSKUQuantity: null,
      amount: null,
      quantity: null,
    };
  },
  computed: {
    productName() {
      return this.variant?.product?.name;
    },
    variant() {
      return this.product?.variant;
    },
    total() {
      if (Number(this.amount) > 0 && Number(this.quantity) > 0) {
        return Number(this.amount) * Number(this.quantity);
      }
      return 0;
    },
  },
  watch: {},
  methods: {
    decimal(value, digits) {
      if (digits == undefined) {
        digits = 2;
      }

      return Number(value).toFixed(digits);
    },
    toggleProcessing() {
      let event = this.shouldProcess
        ? "add-to-processing"
        : "remove-from-processing";

      this.$emit(event, this.processingValues());
    },
    updateProcessing() {
      if (!this.shouldProcess) {
        return;
      }
      this.$emit("update-processing", this.processingValues());
    },
    processingValues() {
      return {
        variant_id: this.product.variant_id,
        sku: this.product.SKU,
        quantity: this.quantity,
        refundAmount: this.amount,
        itemNumber: this.product.ItemNumber,
        totalAmount: this.total,
      };
    },
  },
};
</script>
